import { useParams, useNavigate } from "react-router-dom";
import { useRecommendations } from "../hooks/useRecommendations";
import ReactGA from "react-ga4";
import PageLayout from "./PageLayout.js";
import "./HomePage.css";
import { useEffect, useState } from "react";

// Podcasts that have been migrated to Rave
const MIGRATED_PODCASTS = ['shameless'];

export default function ShowPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sortMode, setSortMode] = useState("best"); // "best" (uses hot algorithm) or "date"

  // Check if this is a migrated podcast
  const isMigrated = MIGRATED_PODCASTS.includes(id?.toLowerCase());

  const { data, isLoading } = useRecommendations(id, sortMode);
  
  // Handle the new API response format
  const records = data?.recommendations || [];
  const podcastName = data?.podcastName || "";
  const podcastImage = data?.podcastImage || "";

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  // Redirect to home if no podcast found (when data is fetched but no podcastName)
  useEffect(() => {
    if (!isLoading && data && !podcastName && !isMigrated) {
      console.log(`No podcast found for "${id}", redirecting to home`);
      navigate("/", { replace: true });
    }
  }, [isLoading, data, podcastName, id, navigate, isMigrated]);

  // Show migration message for migrated podcasts
  if (isMigrated) {
    return (
      <div className="migration-page">
        <div className="migration-content">
          <p className="migration-greeting">Hello!</p>
          <p>
            All Shameless recs have been moved to:
          </p>
          <a 
            href="https://rave.us/pod-recs" 
            target="_blank" 
            rel="noopener noreferrer"
            className="migration-link"
          >
            rave.us/pod-recs
          </a>
          <p className="migration-story">
            A year ago, I decided I wanted more genuine recommendations. I was sick of the algorithm, I wanted things with taste.
          </p>
          <p className="migration-story">
            I started with Pod Recs, Shameless specifically, because I love the girls' taste. I wanted to be able to see everything they'd recommended, and use it to discover new things.
          </p>
          <p className="migration-story">
            Thanks to all of you, Pod Recs took off, and I was able to continue building. A week ago, I launched Rave - <strong>a daily recommendation, in your inbox at 7am, matched to your taste. No algorithms, no ads and no AI.</strong>
          </p>
          <p className="migration-story">
            The Shameless recs are moving there, and if you're interested in a daily rec, you can sign up there too :)
          </p>
          <p className="migration-story">
            Enjoy, and please let me know what you think!
          </p>
          <p className="migration-signature">
            Steph x
          </p>
          <p className="migration-contact">
            <a href="mailto:steph@rave.us">steph@rave.us</a>
          </p>
          
          <div className="migration-photo-container">
            <img 
              src="/steph-working.jpeg" 
              alt="Steph working on Rave" 
              className="migration-photo"
            />
            <div className="migration-photo-caption">
              <span className="migration-arrow">↑</span>
              me working hard on Rave!
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {podcastName && (
        <div className="podcast-header">
          {podcastImage && (
            <img 
              src={podcastImage} 
              alt={podcastName}
              className="podcast-image"
            />
          )}
          <h1 className="podcast-title">{podcastName}</h1>
        </div>
      )}
      <PageLayout
        records={records}
        loading={isLoading}
        hideSort={false}
        podcastName={podcastName}
        sortMode={sortMode}
        setSortMode={setSortMode}
      />
    </div>
  );
}
